import {API_PASSPORT} from './api-passport'
import {AVATARS} from './avatars'
import {MAPS_PRESET} from './maps'
import {METRICA} from './metrica'
import {RUM} from './rum'
import {S3} from './s3'
import {YA_AUTHPROXY} from './ya-authproxy'

export const PRODUCTION = {
  MAPS_PRESET,
  AVATARS,
  METRICA,
  RUM,
  S3,
  YA_AUTHPROXY,
  API_PASSPORT,
}
